<template>
  <v-row style="margin-top:10px !important">
    <v-col>
      <!-- <label>Pénzügyi szűrési feltételek</label> -->
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('Partner') }}</label>
        </v-col>
        <v-col>
          <multi-partner-search
            style="margin-bottom: 10px;"
            :value.sync="filters.partners"
            :partnerId.sync="filters.partnerFilters"
          ></multi-partner-search>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('EredetiPartner') }}</label>
        </v-col>
        <v-col>
          <v-text-field
            outlined
            dense
            hide-details="auto"
            style="margin-bottom: 10px;"
            v-model="filters.origPartner"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_FizetesiStatusz') }}</label>
        </v-col>
        <v-col>
          <multi-select
            :placeholder="$t('CurrentAccount_Mind')"
            :no-data-text="$t('NincsAdat')"
            item-value="id"
            item-text="name"
            outlined
            :items="statusFilters"
            v-model="filters.statusFilters"
            dense
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_SzamlakLejaratSzerint') }}</label>
        </v-col>
        <v-col>
          <v-select
            :no-data-text="$t('NincsAdat')"
            item-value="id"
            item-text="name"
            outlined
            :items="expirationFilters"
            v-model.number="filters.expirationFilter"
            dense
          />
        </v-col>
      </v-row>
      <v-row v-if="isVisibleDateFiltersDaysFilter">
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_HanyNapjaJartLe') }}</label>
        </v-col>
        <v-col>
          <NumericTextBox
            style="margin-bottom:18px"
            v-model="filters.expirationDaysFilter"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('Devizanem') }}</label>
        </v-col>
        <v-col>
          <currency-select
            :placeholder="$t('CurrentAccount_Mind')"
            :multiselect="true"
            v-model="filters.currencyFilters"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_PartnerTipusa') }}</label>
        </v-col>
        <v-col>
          <multi-select
            itemText="name"
            itemValue="id"
            :placeholder="$t('CurrentAccount_Mind')"
            :items="partnerTypeFilters"
            :returnObject="false"
            v-model="filters.partnerTypeFilters"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('Elolegbekerok') }}</label>
        </v-col>
        <v-col>
          <v-select
            item-text="name"
            item-value="id"
            :no-data-text="$t('NincsAdat')"
            outlined
            :items="advanceRequestTypeFilters"
            v-model="filters.advanceRequestTypeFilter"
            dense
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_KeszletfinanszirozottSzamlak') }}</label>
        </v-col>
        <v-col>
          <v-select
            item-text="name"
            item-value="id"
            :no-data-text="$t('NincsAdat')"
            outlined
            :items="stockFinFilters"
            v-model.number="filters.stockFinFilter"
            dense
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_GeniJovahagyasAllapot') }}</label>
        </v-col>
        <v-col>
          <multi-select
            :placeholder="$t('CurrentAccount_Mind')"
            :no-data-text="$t('NincsAdat')"
            item-value="id"
            item-text="name"
            outlined
            :items="preStatusFilters"
            v-model="filters.preStatusFilter"
            dense
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_BankMegjegyzes') }}</label>
        </v-col>
        <v-col>
          <v-text-field
            :placeholder="$t('CurrentAccount_Mind')"
            outlined
            v-model="filters.paymentRemarks"
            dense
            clearable
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <!-- <label>Könyvelési szűrési feltételek</label> -->
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('FokonyviFeladas') }}</label>
        </v-col>
        <v-col>
          <v-select
            item-text="name"
            item-value="id"
            :no-data-text="$t('NincsAdat')"
            outlined
            :items="ledgerPostingFilters"
            v-model="filters.ledgerPostingFilter"
            dense
          />
        </v-col>
      </v-row>
      <v-row>
        <!-- <v-col sm="4">
          <label class="input-label">Főkönyvet alátámasztó analitikák</label>
        </v-col>
        <v-col> </v-col> -->
      </v-row>
      <!-- <label>Dátum szűrések</label> -->
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_BizonylatDatumra') }}</label>
        </v-col>
        <v-col>
          <v-row>
            <v-btn outlined class="src-btn" style="height: 31px !important">
              <v-icon x-small>fa-clock-o</v-icon>
            </v-btn>
            <date-input v-model="filters.proofDateFrom" />
            <span style="width: 32px; text-align: center; padding-top: 7px"
              >-</span
            >
            <date-input v-model="filters.proofDateTo" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_BizonylatFizetesiHataridore') }}</label>
        </v-col>
        <v-col>
          <v-row>
            <v-btn outlined class="src-btn" style="height: 31px !important">
              <v-icon x-small>fa-clock-o</v-icon>
            </v-btn>
            <date-input v-model="filters.proofPaymentDeadlineFrom" />
            <span style="width: 32px; text-align: center; padding-top: 7px"
              >-</span
            >
            <date-input v-model="filters.proofPaymentDeadlineTo" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label"
            >{{ $t('CurrentAccount_BizonylatKonyvelesiFeladasDatumra') }}</label
          >
        </v-col>
        <v-col>
          <v-row>
            <v-btn outlined class="src-btn" style="height: 31px !important">
              <v-icon x-small>fa-clock-o</v-icon>
            </v-btn>
            <date-input v-model="filters.proofPostingDateFrom" />
            <span style="width: 32px; text-align: center; padding-top: 7px"
              >-</span
            >
            <date-input v-model="filters.proofPostingDateTo" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_FizetesiTetelDatumara') }}</label>
        </v-col>
        <v-col>
          <v-row>
            <v-btn outlined class="src-btn" style="height: 31px !important">
              <v-icon x-small>fa-clock-o</v-icon>
            </v-btn>
            <date-input v-model="filters.paymentItemDateFrom" />
            <span style="width: 32px; text-align: center; padding-top: 7px"
              >-</span
            >
            <date-input v-model="filters.paymentItemDateTo" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label">{{ $t('CurrentAccount_FizetesiTetelKeletkezesiDatumara') }}</label>
        </v-col>
        <v-col>
          <v-row>
            <v-btn outlined class="src-btn" style="height: 31px !important">
              <v-icon x-small>fa-clock-o</v-icon>
            </v-btn>
            <date-input v-model="filters.paymentItemInsertDateFrom" />
            <span style="width: 32px; text-align: center; padding-top: 7px"
              >-</span
            >
            <date-input v-model="filters.paymentItemInsertDateTo" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4">
          <label class="input-label"
            >{{ $t('CurrentAccount_FizetesiTetelKonyvelesiFeladasDatumra') }}</label
          >
        </v-col>
        <v-col>
          <v-row>
            <v-btn outlined class="src-btn" style="height: 31px !important">
              <v-icon x-small>fa-clock-o</v-icon>
            </v-btn>
            <date-input v-model="filters.paymentItemPostingDateFrom" />
            <span style="width: 32px; text-align: center; padding-top: 7px"
              >-</span
            >
            <date-input v-model="filters.paymentItemPostingDateTo" />
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import MultiSelect from "@/components//MultiSelect.vue";
import { NumericTextBox } from "@progress/kendo-vue-inputs";
import CurrencySelect from "@/components/CurrencySelect.vue";
import DateInput from "@/components/DateInput.vue";
import MultiPartnerSearch from "@/modules/partner/views/MultiPartnerSearch.vue";
import { getPartnerTypes } from "@/modules/currentAccount/api/PartnerTypesApi";
import eventBus from "@/services/eventBus";
import ApiSearch from "@/components/apiSearch/models/ApiSearch";
import CurrentAccountPreFilters from "@/modules/currentAccount/models/CurrentAccountPreFilters";
import { t } from "@/plugins/i18n";

export default {
  async beforeMount() {
    this.partnerTypeFilters = await getPartnerTypes();
  },
  mounted() {
    if (this.apiSearch?.extraFilter) this.filters = this.apiSearch.extraFilter;
    else this.apiSearch.extraFilter = this.filters;

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari){
      console.log('safari');

      this.filters.proofDateFrom = new Date();
      this.filters.proofDateTo = new Date();
      this.filters.proofPaymentDeadlineFrom = new Date();
      this.filters.proofPaymentDeadlineTo = new Date();
      this.filters.proofPostingDateFrom = new Date();
      this.filters.proofPostingDateTo = new Date();
      this.filters.paymentItemDateFrom = new Date();
      this.filters.paymentItemDateTo = new Date();
      this.filters.paymentItemInsertDateFrom = new Date();
      this.filters.paymentItemInsertDateTo =  new Date();
      this.filters.paymentItemPostingDateFrom = new Date();
      this.filters.paymentItemPostingDateTo = new Date();
    }
  },
  data() {
    return {
      partnerTypeFilters: [],
      filters: new CurrentAccountPreFilters(),
    };
  },
  components: {
    MultiSelect,
    NumericTextBox,
    CurrencySelect,
    DateInput,
    MultiPartnerSearch,
  },
  props: {
    apiSearch: ApiSearch,
  },
  watch: {
    "filters.partnerFilters"() {
      const length = this.filters.partnerFilters.length ?? 0;
      eventBus.$emit("multipartner-select-changed", length);
    },
    // filters() {
    //   this.apiSearch.extraFilter = this.filters;
    // },
    apiSearch(newValue) {
      if (newValue?.extraFilter) this.filters = newValue.extraFilter;
      else this.apiSearch.extraFilter = this.filters;
    },
  },
  computed: {
    statusFilters: () => [
      { name: "Nyitott", id: 0 },
      { name: t("CurrentAccount_ReszbenFizetett"), id: 1 },
      { name: "Rendezettek", id: 2 },
    ],
    expirationFilters: () => [
      { name: "Mind", id: 0 },
      { name: t("CurrentAccount_CsakALejartSzamlak"), id: 1 },
      { name: t("CurrentAccount_CsakAzXNapnalRegebbenLejart"), id: 2 },
    ],
    isVisibleDateFiltersDaysFilter() {
      if (this.filters.expirationFilter == undefined) return false;

      return this.filters.expirationFilter == this.expirationFilters[2].id;
    },
    advanceRequestTypeFilters: () => [
      { name: t("CurrentAccount_FolyoszamlaElolegbekerokkel"), id: 0 },
      { name: t("CurrentAccount_ElolegbekerokNelkul"), id: 1 },
      { name: t("CurrentAccount_CsakElolegbekerok"), id: 2 },
    ],
    stockFinFilters: () => [
      { name: "Mind", id: 0 },
      { name: t("CurrentAccount_CsakKeszletfinanszirozottSzamlak"), id: 1 },
      { name: t("CurrentAccount_CsakNemKeszletfinanszirozottSzamlak"), id: 2 },
    ],
    ledgerPostingFilters: () => [
      { name: t("CurrentAccount_MindenFolyoszamlatetel"), id: 0 },
      { name: t("CurrentAccount_CsakAFokonyvFeleFeladottFolyoszamlatetelek"), id: 1 },
    ],
    preStatusFilters: () => [
      { name: "-", id: 1 },
      { name: t("FeldolgozasAlatt"), id: 2 },
      { name: t("CurrentAccount_Erkezett"), id: 3 },
      { name: t("CurrentAccount_MegNemElfogadhato"), id: 5 },
      { name: t("Jovairt"), id: 5 },
      { name: t("CurrentAccount_ElutasitvaViszak"), id: 7 },
      { name: "Elfogadva", id: 8 },
      { name: t("CurrentAccount_ElfogadottFeldolgozasAlatt"), id: 9 },
      { name: t("CurrentAccount_ElolegszBaBeszamitottErt"), id: 10 },
      { name: t("CurrentAccount_JovahagyastNemIgenyloKulso"), id: 11 },
    ],
  },
};
</script>

<style></style>
